module.exports = __webpack_public_path__ + "static/media/down-arrow.46df20f8.svg";